/**
 * Client-side price calculator.
 */

/**
 * Format a price as EUR.
 */
export function formatPrice(amount) {
    return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
    }).format(amount);
}

/**
 * Calculate total from selected options.
 *
 * @param {Array} selectedOptions - Array of { option_id, price, quantity }
 * @param {Set} includedPriceIds - Option IDs whose price is included (zero-priced).
 * @param {number} vatPercentage - VAT percentage (default 21).
 * @returns {{ subtotal, vatAmount, total, lines }}
 */
export function calculateTotal(selectedOptions, includedPriceIds = new Set(), vatPercentage = 21) {
    let subtotal = 0;
    const lines = [];

    for (const opt of selectedOptions) {
        const quantity = opt.quantity || 1;
        const isIncluded = includedPriceIds.has(Number(opt.option_id));
        const isOnRequest = opt.price_type === 'on_request';
        const isNone = opt.price_type === 'none';
        const effectivePrice = (isIncluded || isOnRequest || isNone) ? 0 : Number(opt.price || 0);
        const lineTotal = effectivePrice * quantity;

        lines.push({
            ...opt,
            effectivePrice,
            lineTotal,
            priceIncluded: isIncluded,
            priceOnRequest: isOnRequest,
            priceNone: isNone,
        });

        subtotal += lineTotal;
    }

    const vatAmount = Math.round(subtotal * (vatPercentage / 100) * 100) / 100;
    const total = Math.round((subtotal + vatAmount) * 100) / 100;

    return {
        lines,
        subtotal: Math.round(subtotal * 100) / 100,
        vatPercentage,
        vatAmount,
        total,
    };
}
